var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "customer-card",
      class: {
        selected: _vm.item._id + "_" + _vm.item.index === _vm.selectedItemId,
      },
      attrs: { "item-id": _vm.item._id + "_" + _vm.item.index },
      on: {
        click: function ($event) {
          return _vm.$emit("select", _vm.item)
        },
      },
    },
    [
      _vm.item.index < 10
        ? _c("span", { staticClass: "index-shortcut-keyboard" }, [
            _vm._v(_vm._s(_vm.item.index)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "customer-info" }, [
        _c("div", { staticClass: "customer-header" }, [
          _c(
            "div",
            { staticClass: "customer-avatar-wrapper" },
            [
              _c("ContactAvatar", {
                attrs: { contact: _vm.contactForAvatar, size: "small" },
              }),
              _vm._v(" "),
              _vm.channelType
                ? _c(
                    "div",
                    { staticClass: "platform-badge" },
                    [
                      _c("PlatformIcon", {
                        attrs: {
                          platform: _vm.channelType,
                          size: 12,
                          "tippy-disabled": true,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "customer-name-section" },
            [
              _c(
                "a-tooltip",
                { attrs: { title: _vm.customerName, mouseEnterDelay: 0.3 } },
                [
                  _c("div", { staticClass: "customer-name-tag" }, [
                    _vm._v(_vm._s(_vm.customerName)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.lastMessage
          ? _c(
              "div",
              { staticClass: "customer-message" },
              [
                _c("ContactLastMessage", {
                  attrs: { lastMessage: _vm.lastMessage },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "metas" }, [
          _c("div", { staticClass: "customer-duration" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("timer")]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.formattedDuration) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "customer-status",
              class: {
                answered: _vm.answerStatus === "answered",
                waiting: _vm.answerStatus !== "answered",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.answerStatus === "answered"
                      ? _vm.$t("report.answered")
                      : _vm.$t("message.waitingForReply")
                  ) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }